import { configureStore } from '@reduxjs/toolkit';
import { apiEndpointReducer } from './apiEndpoint';
import { currentFormReducer } from './currentForm';
import { currentPageStateReducer } from './currentPageState';
import { drillDownReducer } from './drillDown';
import { fileUploadReducer } from './fileUpload';
import { reCaptchaReducer } from './reCaptcha';

export const store = configureStore({
  reducer: {
    currentPageState: currentPageStateReducer,
    currentForm: currentFormReducer,
    reCaptcha: reCaptchaReducer,
    apiEndpoint: apiEndpointReducer,
    fileUpload: fileUploadReducer,
    drillDown: drillDownReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
